var map = {
	"./alert/balance.png": 51693,
	"./alert/bg-balance.png": 7067,
	"./alert/learning.png": 46979,
	"./alert/social.png": 3412,
	"./apexchart/radial-image.png": 68202,
	"./avatars/1.jpg": 86332,
	"./avtar/11.jpg": 36067,
	"./avtar/16.jpg": 94416,
	"./avtar/3.jpg": 14614,
	"./avtar/4.jpg": 20957,
	"./avtar/7.jpg": 83154,
	"./banner/1.jpg": 226,
	"./banner/2.jpg": 46157,
	"./banner/3.jpg": 93936,
	"./big-lightgallry/01.jpg": 16380,
	"./big-lightgallry/010.jpg": 52878,
	"./big-lightgallry/011.jpg": 79339,
	"./big-lightgallry/012.jpg": 11644,
	"./big-lightgallry/013.jpg": 25369,
	"./big-lightgallry/014.jpg": 96426,
	"./big-lightgallry/015.jpg": 35431,
	"./big-lightgallry/016.jpg": 56504,
	"./big-lightgallry/02.jpg": 1035,
	"./big-lightgallry/03.jpg": 22990,
	"./big-lightgallry/04.jpg": 58613,
	"./big-lightgallry/05.jpg": 37944,
	"./big-lightgallry/06.jpg": 34279,
	"./big-lightgallry/07.jpg": 66538,
	"./big-lightgallry/08.jpg": 37649,
	"./big-lightgallry/09.jpg": 65844,
	"./big-masonry/1.jpg": 31302,
	"./big-masonry/10.jpg": 4764,
	"./big-masonry/11.jpg": 91641,
	"./big-masonry/12.jpg": 11374,
	"./big-masonry/13.jpg": 89419,
	"./big-masonry/14.jpg": 26328,
	"./big-masonry/15.jpg": 46997,
	"./big-masonry/2.jpg": 89073,
	"./big-masonry/3.jpg": 10548,
	"./big-masonry/4.jpg": 12511,
	"./big-masonry/5.jpg": 76162,
	"./big-masonry/6.jpg": 24653,
	"./big-masonry/7.jpg": 81200,
	"./big-masonry/8.jpg": 36107,
	"./big-masonry/9.jpg": 9646,
	"./blog/12.png": 15140,
	"./blog/14.png": 98930,
	"./blog/4.jpg": 76553,
	"./blog/9.jpg": 56608,
	"./blog/blog-2.jpg": 78052,
	"./blog/blog-3.jpg": 68001,
	"./blog/blog-5.jpg": 20783,
	"./blog/blog-6.jpg": 30464,
	"./blog/blog-single.jpg": 86240,
	"./blog/blog.jpg": 6617,
	"./blog/comment.jpg": 16526,
	"./blog/img.png": 24044,
	"./customizer/dark.png": 81446,
	"./customizer/light.png": 35480,
	"./customizer/mix.png": 7606,
	"./dashboard-1/hand.png": 59802,
	"./dashboard-1/icon/1.png": 38006,
	"./dashboard-1/icon/2.png": 28685,
	"./dashboard-1/icon/3.png": 86180,
	"./dashboard-1/icon/4.png": 96123,
	"./dashboard-1/icon/5.png": 47122,
	"./dashboard-1/icon/6.png": 12265,
	"./dashboard-1/icon/cancel.png": 32433,
	"./dashboard-1/icon/checked.png": 85716,
	"./dashboard-1/icon/danger.png": 58710,
	"./dashboard-1/img-1.png": 46170,
	"./dashboard-1/img-2.png": 54481,
	"./dashboard-1/img-3.png": 14536,
	"./dashboard-1/img-4.png": 6055,
	"./dashboard-1/img-5.png": 18366,
	"./dashboard-1/news-update/1.png": 27436,
	"./dashboard-1/news-update/2.png": 47495,
	"./dashboard-1/news-update/3.png": 29182,
	"./dashboard-1/news-update/4.png": 70193,
	"./dashboard-1/news-update/5.png": 72328,
	"./dashboard-1/news-update/6.png": 57603,
	"./dashboard-1/news-update/7.png": 40026,
	"./dashboard-1/user/01.png": 30188,
	"./dashboard-1/user/02.png": 66599,
	"./dashboard-1/user/03.png": 48286,
	"./dashboard-1/user/04.png": 89297,
	"./dashboard-1/user/05.png": 75080,
	"./dashboard-1/user/06.png": 60355,
	"./dashboard-1/user/07.png": 59130,
	"./dashboard-1/user/1.png": 17240,
	"./dashboard-1/user/2.png": 62995,
	"./dashboard-1/user/3.png": 24138,
	"./dashboard-1/welcome-bg.png": 11281,
	"./dashboard-2/1.png": 41555,
	"./dashboard-2/2.png": 50712,
	"./dashboard-2/3.png": 23425,
	"./dashboard-2/4.png": 56686,
	"./dashboard-2/5.png": 30327,
	"./dashboard-2/6.png": 41596,
	"./dashboard-2/animate/1.png": 74171,
	"./dashboard-2/animate/2 (1).png": 47058,
	"./dashboard-2/animate/2.png": 95840,
	"./dashboard-2/animate/3.png": 90313,
	"./dashboard-2/animate/4.png": 50230,
	"./dashboard-2/animate/5.png": 47167,
	"./dashboard-2/flag/1.png": 62278,
	"./dashboard-2/flag/2.png": 3517,
	"./dashboard-2/flag/3.png": 82388,
	"./dashboard-2/flag/4.png": 28299,
	"./dashboard-2/flag/5.png": 7170,
	"./dashboard-2/timeline/5.png": 14985,
	"./dashboard-2/timeline/6.png": 66802,
	"./dashboard-2/user/01.png": 61843,
	"./dashboard-2/user/02.png": 66232,
	"./dashboard-2/user/03.png": 87361,
	"./dashboard-2/user/04.png": 72526,
	"./dashboard-2/user/05.png": 72023,
	"./dashboard-2/user/06.png": 64444,
	"./dashboard-2/user/07.png": 357,
	"./dashboard-2/user/08.png": 95330,
	"./dashboard-2/user/09.png": 69483,
	"./dashboard-2/user/10.png": 52853,
	"./dashboard-2/user/11.png": 16940,
	"./dashboard-2/user/12.png": 19591,
	"./dashboard-2/user/13.png": 67102,
	"./dashboard-2/user/14.png": 50193,
	"./dashboard-2/user/15.png": 39976,
	"./dashboard-2/user/16.png": 93187,
	"./dashboard-2/user/17.png": 29082,
	"./dashboard-2/user/18.png": 86861,
	"./dashboard-3/user/1.png": 93854,
	"./dashboard-3/user/10.png": 83548,
	"./dashboard-3/user/11.png": 66437,
	"./dashboard-3/user/12.png": 96078,
	"./dashboard-3/user/13.png": 41655,
	"./dashboard-3/user/14.png": 92664,
	"./dashboard-3/user/15.png": 13793,
	"./dashboard-3/user/16.png": 99562,
	"./dashboard-3/user/17.png": 38419,
	"./dashboard-3/user/18.png": 43124,
	"./dashboard-3/user/19.png": 76157,
	"./dashboard-3/user/2.png": 44853,
	"./dashboard-3/user/20.png": 48145,
	"./dashboard-3/user/21.png": 99752,
	"./dashboard-3/user/22.png": 61731,
	"./dashboard-3/user/3.png": 75756,
	"./dashboard-3/user/4.png": 5923,
	"./dashboard-3/user/5.png": 4698,
	"./dashboard-3/user/6.png": 34865,
	"./dashboard-3/user/7.png": 20648,
	"./dashboard-3/user/8.png": 2911,
	"./dashboard-3/user/9.png": 6582,
	"./details_close.png": 33441,
	"./details_open.png": 32005,
	"./ecommerce/01.jpg": 57782,
	"./ecommerce/02.jpg": 7393,
	"./ecommerce/03.jpg": 29348,
	"./ecommerce/04.jpg": 55727,
	"./ecommerce/05.jpg": 79346,
	"./ecommerce/06.jpg": 98301,
	"./ecommerce/07.jpg": 89088,
	"./ecommerce/08.jpg": 71867,
	"./ecommerce/banner.jpg": 50689,
	"./ecommerce/card.png": 96633,
	"./ecommerce/mastercard.png": 99007,
	"./ecommerce/paypal.png": 86894,
	"./ecommerce/product-table-1.png": 20919,
	"./ecommerce/product-table-2.png": 96988,
	"./ecommerce/product-table-3.png": 32901,
	"./ecommerce/product-table-4.png": 62474,
	"./ecommerce/product-table-5.png": 94387,
	"./ecommerce/product-table-6.png": 98776,
	"./ecommerce/visa.png": 90884,
	"./email-template/1.jpg": 52235,
	"./email-template/1.png": 77171,
	"./email-template/10.jpg": 19955,
	"./email-template/11.jpg": 56790,
	"./email-template/12.jpg": 46369,
	"./email-template/2.png": 31416,
	"./email-template/3.png": 52545,
	"./email-template/4.png": 34830,
	"./email-template/5.png": 64055,
	"./email-template/6.png": 5948,
	"./email-template/7.jpg": 9813,
	"./email-template/7.png": 88837,
	"./email-template/8.jpg": 72998,
	"./email-template/8.png": 94306,
	"./email-template/banner-2.jpg": 55723,
	"./email-template/banner.jpg": 7838,
	"./email-template/cosmetic.jpg": 2949,
	"./email-template/delivery-2.png": 71997,
	"./email-template/delivery.png": 43000,
	"./email-template/facebook.png": 10004,
	"./email-template/gplus.png": 66457,
	"./email-template/invoice-1/1.png": 21457,
	"./email-template/invoice-1/sign.png": 85249,
	"./email-template/invoice-3/bg-0.png": 14498,
	"./email-template/invoice-3/bg.png": 20881,
	"./email-template/invoice-3/sign.png": 11007,
	"./email-template/linkedin.png": 78634,
	"./email-template/order-success.png": 81852,
	"./email-template/pdfs.png": 77921,
	"./email-template/pinterest.png": 18708,
	"./email-template/slider.jpg": 52123,
	"./email-template/space.jpg": 36844,
	"./email-template/success.png": 96343,
	"./email-template/twitter.png": 23579,
	"./email-template/youtube.png": 27197,
	"./email/3.jpg": 26600,
	"./faq/1.jpg": 18398,
	"./faq/2.jpg": 97993,
	"./faq/3.jpg": 42732,
	"./faq/4.jpg": 32695,
	"./faq/learning-1.png": 23111,
	"./favicon.png": 70170,
	"./file-manager/folder.png": 45689,
	"./file-manager/folder1.png": 41460,
	"./forms/Bank-of-Baroda.png": 56326,
	"./forms/MasterCard.png": 98852,
	"./forms/SCB.png": 89986,
	"./forms/authenticate.png": 39159,
	"./forms/axis.png": 55287,
	"./forms/credit-card.png": 64396,
	"./forms/delivery.png": 93660,
	"./forms/email.png": 9582,
	"./forms/flags.png": 36287,
	"./forms/hdfc.png": 69493,
	"./forms/idbi.png": 23588,
	"./forms/qr-bg.jpg": 12321,
	"./forms/qr-code.png": 17199,
	"./forms/qr-scan.png": 3859,
	"./forms/qr-scan1.png": 36466,
	"./forms/rbl.png": 20066,
	"./forms/us-bank.png": 43245,
	"./forms/user.png": 92157,
	"./gif/danger.gif": 32467,
	"./gif/facebook.gif": 99202,
	"./gif/instagram.gif": 93462,
	"./gif/logout.gif": 52496,
	"./gif/online-shopping.gif": 48196,
	"./gif/qr-scan.gif": 86631,
	"./gif/success/successful.gif": 16224,
	"./gif/whatapp.gif": 80381,
	"./job-search/1.jpg": 82718,
	"./job-search/2.jpg": 57865,
	"./job-search/3.jpg": 60076,
	"./job-search/4.jpg": 20311,
	"./job-search/5.jpg": 68378,
	"./job-search/6.jpg": 25605,
	"./knowledgebase/bg_1.jpg": 88655,
	"./lightgallry/01.jpg": 96399,
	"./lightgallry/010.jpg": 45695,
	"./lightgallry/011.jpg": 53986,
	"./lightgallry/012.jpg": 99917,
	"./lightgallry/013.jpg": 47696,
	"./lightgallry/014.jpg": 23971,
	"./lightgallry/015.jpg": 80838,
	"./lightgallry/016.jpg": 8593,
	"./lightgallry/02.jpg": 82784,
	"./lightgallry/03.jpg": 38365,
	"./lightgallry/04.jpg": 90550,
	"./lightgallry/05.jpg": 53715,
	"./lightgallry/06.jpg": 18436,
	"./lightgallry/07.jpg": 96481,
	"./lightgallry/08.jpg": 5338,
	"./lightgallry/09.jpg": 99799,
	"./lightgallry/default-skin.png": 26569,
	"./lightgallry/default-skin.svg": 34527,
	"./login/1.jpg": 76369,
	"./login/2.jpg": 44166,
	"./login/3.jpg": 34275,
	"./login/icon.png": 21997,
	"./login/login_bg.jpg": 87665,
	"./logo/logo-dark.png": 19186,
	"./logo/logo1.webp": 55856,
	"./logo/range.svg": 8045,
	"./logo/range2.svg": 70533,
	"./logo/range3.svg": 15812,
	"./logo/range4.svg": 77963,
	"./logo/range5.svg": 58906,
	"./masonry/1.jpg": 61419,
	"./masonry/10.jpg": 74739,
	"./masonry/11.jpg": 3126,
	"./masonry/12.jpg": 52737,
	"./masonry/13.jpg": 74692,
	"./masonry/14.jpg": 17423,
	"./masonry/15.jpg": 41042,
	"./masonry/2.jpg": 36252,
	"./masonry/3.jpg": 80601,
	"./masonry/4.jpg": 78506,
	"./masonry/5.jpg": 90663,
	"./masonry/6.jpg": 57816,
	"./masonry/7.jpg": 18997,
	"./masonry/8.jpg": 82790,
	"./masonry/9.jpg": 21315,
	"./other-images/bg-profile.png": 63887,
	"./other-images/boxbg.jpg": 70138,
	"./other-images/coming-soon-bg.jpg": 81823,
	"./other-images/dark-logo-login.png": 94796,
	"./other-images/emoji/angry.png": 61884,
	"./other-images/emoji/love.png": 18747,
	"./other-images/emoji/sad.png": 20655,
	"./other-images/emoji/smile.png": 92847,
	"./other-images/emoji/think.png": 56027,
	"./other-images/headphones.png": 87819,
	"./other-images/img-1.jpg": 94735,
	"./other-images/img-2.jpg": 4416,
	"./other-images/img-3.jpg": 72509,
	"./other-images/img-4.jpg": 66166,
	"./other-images/img-cropper.jpg": 68697,
	"./other-images/invoice.svg": 58411,
	"./other-images/logo-login.png": 80099,
	"./other-images/maintenance-bg.jpg": 58465,
	"./other-images/mountain.jpg": 49279,
	"./other-images/paypal.png": 33687,
	"./other-images/profile-bg.png": 70511,
	"./other-images/profile-style-img.png": 40461,
	"./other-images/profile-style-img3.png": 14466,
	"./other-images/profile.png": 74247,
	"./other-images/sea.jpg": 22389,
	"./other-images/sidebar-bg.jpg": 42270,
	"./product-1/1.png": 52677,
	"./product-1/2.png": 82318,
	"./product-1/3.png": 27895,
	"./product-1/4.png": 78904,
	"./product/1.png": 82983,
	"./product/10.png": 44167,
	"./product/11.png": 56478,
	"./product/12.png": 42229,
	"./product/13.png": 75692,
	"./product/14.png": 89507,
	"./product/15.png": 84282,
	"./product/2.png": 62924,
	"./product/3.png": 32021,
	"./product/4.png": 75514,
	"./product/category/1.png": 53624,
	"./product/category/2.png": 28115,
	"./product/category/3.png": 72906,
	"./product/category/4.png": 57573,
	"./product/category/5.png": 44508,
	"./product/product-categories/1.png": 55762,
	"./product/product-categories/2.png": 46473,
	"./product/product-categories/drone.png": 80517,
	"./product/product-categories/dvd.png": 96377,
	"./product/product-categories/headphone.png": 91037,
	"./product/product-categories/ipad.png": 60151,
	"./product/product-categories/keyboard.png": 91476,
	"./product/product-categories/laptop.png": 97327,
	"./product/product-categories/mac-laptop.png": 2885,
	"./product/product-categories/mouse.png": 24570,
	"./product/product-categories/phone.png": 15567,
	"./product/product-categories/speaker.png": 47552,
	"./product/product-categories/watch-2.png": 20099,
	"./product/product-categories/watch.png": 34154,
	"./product/product-categories/wireless-headphone.png": 76454,
	"./profile.png": 27173,
	"./scrollbar/fashion1.jpg": 17160,
	"./scrollbar/fashion2.jpg": 1911,
	"./scrollbar/fashion3.jpg": 38074,
	"./scrollbar/fashion4.jpg": 58761,
	"./scrollbar/fashion5.jpg": 20716,
	"./scrollbar/fashion6.jpg": 63515,
	"./slider/1.jpg": 31719,
	"./slider/10.jpg": 65639,
	"./slider/11.jpg": 9802,
	"./slider/2.jpg": 52792,
	"./slider/3.jpg": 60053,
	"./slider/4.jpg": 49166,
	"./slider/5.jpg": 75627,
	"./slider/6.jpg": 7932,
	"./slider/7.jpg": 5305,
	"./slider/8.jpg": 15682,
	"./slider/9.jpg": 35679,
	"./social-app/post-1.png": 924,
	"./social-app/post-2.png": 59031,
	"./social-app/post-3.png": 13454,
	"./social-app/post-4.png": 31169,
	"./social-app/post-5.png": 10040,
	"./social-app/post-6.png": 55795,
	"./social-app/post-7.png": 586,
	"./social-app/post-8.png": 93533,
	"./social-app/post-9.png": 60500,
	"./social-app/social-image.png": 68709,
	"./social-app/timeline-1.png": 51763,
	"./social-app/timeline-2.png": 39800,
	"./social-app/timeline-3.png": 60929,
	"./social-app/timeline-4.png": 62446,
	"./start-conversion.jpg": 1037,
	"./switch/1.jpg": 32360,
	"./switch/2.jpg": 59639,
	"./switch/3.jpg": 72122,
	"./switch/4.jpg": 8585,
	"./switch/5.jpg": 53324,
	"./switch/6.jpg": 13947,
	"./switch/7.jpg": 28990,
	"./switch/8.jpg": 56733,
	"./switch/square-gray.png": 96710,
	"./switch/square.svg": 16044,
	"./user/1.jpg": 65585,
	"./user/1.png": 10777,
	"./user/10.jpg": 87341,
	"./user/11.jpg": 18768,
	"./user/11.png": 33044,
	"./user/12.jpg": 33119,
	"./user/12.png": 38159,
	"./user/14.jpg": 79665,
	"./user/14.png": 75385,
	"./user/16.png": 82955,
	"./user/2.jpg": 33382,
	"./user/2.png": 71042,
	"./user/3.jpg": 23491,
	"./user/3.png": 92171,
	"./user/4.jpg": 4688,
	"./user/4.png": 42260,
	"./user/5.jpg": 49581,
	"./user/5.png": 58941,
	"./user/6.jpg": 80354,
	"./user/7.jpg": 72063,
	"./user/8.jpg": 44316,
	"./user/9.jpg": 14841,
	"./user/img.png": 46253,
	"./user/user-dp.png": 88810,
	"./user/user.png": 17907,
	"./users/1.png": 13042,
	"./users/2.png": 3753,
	"./users/3.png": 48928,
	"./users/4.png": 255,
	"./users/5.png": 3926,
	"./users/6.png": 85549,
	"./widget-bg.png": 44350,
	"./widget/widget-bg.png": 48949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34002;